export default "__VITE_ASSET__pSczLLC$__"